export default function ExpressionEvalValue({
  evaluationValue,
}: {
  evaluationValue: string;
}) {
  return (
    <span className="expn-eval-value">
      {evaluationValue?.split(",").map((value, index) => {
        return value && <span key={`${value}-${index}`}>{value}</span>;
      })}
    </span>
  );
}
